<template>
  <section class="super-touch-oversea">
    <div class="fluent-mobile-background"></div>
    <div v-textMotion="50" :class="{ zh: lang === 'zh' }" class="text1">
      <div v-if="lang === 'zh'" class="title">
        <p>{{ $t('super-touch-title1') }}</p>
        <p>{{ $t('super-touch-title2') }}</p>
      </div>
      <p v-else class="title">{{ $t('super-touch-title') }}</p>
      <p class="description">{{ $t('super-touch-description') }}</p>
    </div>
    <div
      class="super-touch-oversea-phone-container wow textInPartMotion"
      data-wow-duration=".7s"
      data-wow-delay="1s"
      data-wow-offset="100"
    >
      <lazy-component
        class="super-touch-oversea-phone-container wow textInPartMotion"
        data-wow-duration=".7s"
        data-wow-delay="1s"
        data-wow-offset="100"
        :class="{
          'svg-hide': videoPlaying,
          'svg-black': videoHasNotPlaying
        }"
        @show="load"
      >
        <video
          v-if="lang !== 'zh'"
          id="super-touch-video-mobile"
          :src="require('../../assets/fluent/super-touch/super-touch-video-en-mobile.mp4')"
          poster="../../assets/fluent/super-touch/poster.jpg"
          muted
          preload="meta"
          x5-playsinline
          webkit-playsinline
          playsinline
          x5-video-player-type="h5"
          x5-video-orientation="portraint"
        ></video>
        <video
          v-else
          id="super-touch-video-mobile"
          :src="require('../../assets/fluent/super-touch/super-touch-video-zh-mobile.mp4')"
          poster="../../assets/fluent/super-touch/poster-zh.jpg"
          muted
          preload="meta"
          x5-playsinline
          webkit-playsinline
          playsinline
          x5-video-player-type="h5"
          x5-video-orientation="portraint"
        ></video>
        <img
          :src="require(`../../assets/fluent/super-touch/poster${lang === 'zh' ? '-zh' : ''}.jpg`)"
          alt="ColorOS 11"
        />
      </lazy-component>
      <play-button-text ref="playButtonText" target-video="#super-touch-video-mobile" />
    </div>
    <div v-textMotion="200" :class="{ zh: lang === 'zh' }" class="text2">
      <div v-if="lang === 'zh'" class="title">
        <p>{{ $t('ai-preloading-title1') }}</p>
        <p>{{ $t('ai-preloading-title2') }}</p>
      </div>
      <p v-else class="title">{{ $t('ai-preloading-title') }}</p>
      <p class="description">{{ $t('ai-preloading-description') }}</p>
    </div>
    <div
      v-if="lang != 'zh'"
      :class="{ 'ai-preloading-icons__active': iconsIsActive }"
      class="ai-preloading-icons wow textInPartMotion"
      data-wow-duration=".7s"
      data-wow-offset="350"
    >
      <div class="line line1">
        <figure class="ai-preloading-icon-container">
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon1b.png')" />
          </transition>
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon1.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/fluent/super-touch/icon2.png`)" alt="ColorOS 11" />
        </figure>
        <figure class="ai-preloading-icon-container">
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon3b.png')" />
          </transition>
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon3.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/fluent/super-touch/icon4.png`)" alt="ColorOS 11" />
        </figure>
      </div>
      <div class="line line2">
        <figure class="ai-preloading-icon-container">
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon5b.png')" />
          </transition>
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon5.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/fluent/super-touch/icon6.png`)" alt="ColorOS 11" />
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/fluent/super-touch/icon7.png`)" alt="ColorOS 11" />
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/fluent/super-touch/icon8.png`)" alt="ColorOS 11" />
        </figure>
      </div>
      <div class="line line3">
        <figure class="ai-preloading-icon-container">
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon9b.png')" />
          </transition>
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon9.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon10b.png')" />
          </transition>
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon10.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon11b.png')" />
          </transition>
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon11.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/fluent/super-touch/icon12.png`)" alt="ColorOS 11" />
        </figure>
      </div>

      <img v-lazy="require(`../../assets/fluent/super-touch/link-h.png`)" class="ai-link-h ai-link-h-1" />
      <img v-lazy="require(`../../assets/fluent/super-touch/link-h.png`)" class="ai-link-h ai-link-h-2" />
      <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-1" />
      <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-2" />
      <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-3" />
    </div>
    <div
      v-else
      :class="{ 'ai-preloading-icons__active': iconsIsActive }"
      class="ai-preloading-icons wow textInPartMotion"
      data-wow-duration=".7s"
      data-wow-offset="350"
    >
      <div class="line line1">
        <figure class="ai-preloading-icon-container">
          <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon1b.png')" />
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon1.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon2b.png')" />
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon2.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require('../../assets/zh/fluent/super-touch/icon3.png')" />
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon4b.png')" />
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon4.png')" />
          </transition>
        </figure>
      </div>
      <div class="line line2">
        <figure class="ai-preloading-icon-container">
          <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon5b.png')" />
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon5.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/zh/fluent/super-touch/icon6.png`)" alt="ColorOS 11" />
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/zh/fluent/super-touch/icon7.png`)" alt="ColorOS 11" />
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/zh/fluent/super-touch/icon8.png`)" alt="ColorOS 11" />
        </figure>
      </div>
      <div class="line line3">
        <figure class="ai-preloading-icon-container">
          <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon9b.png')" />
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon9.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon10.png')" />
          </transition>
          <transition name="fade-in">
            <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon10b.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <!-- <transition name="fade-in"> -->
          <img v-show="iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon11b.png')" />
          <!-- </transition> -->
          <transition name="fade-out">
            <img v-show="!iconsIsActive" v-lazy="require('../../assets/zh/fluent/super-touch/icon11.png')" />
          </transition>
        </figure>
        <figure class="ai-preloading-icon-container">
          <img v-lazy="require(`../../assets/zh/fluent/super-touch/icon12.png`)" alt="ColorOS 11" />
        </figure>
      </div>

      <img v-lazy="require(`../../assets/fluent/super-touch/link-h.png`)" class="ai-link-h ai-link-h-1" />
      <img v-lazy="require(`../../assets/fluent/super-touch/link-h.png`)" class="ai-link-h ai-link-h-2" />
      <img
        v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)"
        class="ai-link-v ai-link-v-1"
        style="left:62.3%"
      />
      <!-- <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-2" /> -->
      <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-3" />
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import PlayButtonText from '@/components/PlayButtonText';
import Controller from '../../util/scrollMagic';
export default {
  inject: ['lang'],
  components: {
    PlayButtonText
  },
  data() {
    return {
      videoPlaying: false,
      videoHasNotPlaying: true,
      iconsIsActive: false
    };
  },
  mounted() {
    new ScrollMagic.Scene({
      triggerElement: '.ai-preloading-icons',
      triggerHook: 0.3
    })
      .addTo(Controller)
      .on('progress', e => {
        if (e.progress === 1 && this.iconsIsActive === false) {
          this.iconsIsActive = true;
        }
        // if (e.progress === 0 && this.iconsIsActive === true) {
        //   this.iconsIsActive = false;
        // }
      });
  },
  methods: {
    handleVideoPlay() {
      this.video.currentTime = 0;
      this.video.play();
      this.videoPlaying = true;
      this.videoHasNotPlaying = false;
      if (!this.added) {
        this.add();
      }
    },
    add() {
      this.added = true;
      this.video.addEventListener('ended', () => {
        this.videoPlaying = false;
      });
    },
    load() {
      setTimeout(() => {
        if (!this.video) {
          this.video = document.getElementById('super-touch-video-mobile');
          if (!this.video) {
            this.load();
          } else {
            this.$refs.playButtonText.init();
          }
        }
      }, 100);
    }
  }
};
</script>
<style lang="scss" scoped>
.text1,
.text2,
.ai-preloading-icons,
.super-touch-oversea-phone-container {
  position: relative;
  z-index: 2;
}
.super-touch-oversea {
  position: relative;
  overflow: hidden;
  // height: 340vw; 没有用吧？改为 min-height: 310vw;
  min-height: 310vw;
  background-color: #f6f6f7;
}

.super-touch-oversea-phone-container {
  position: relative;
  font-size: 0;
  width: 64.8vw;
  height: 142vw;
  margin: 10.66vw auto 21.33vw;
  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  video,
  img {
    object-fit: fill;
    width: 100%;
    /* height: 100%; */
  }
  video {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
}
.text1,
.text2 {
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  text-align: left;
  .title {
    font-variation-settings: 'wght' 1000;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
  }
  .description {
    padding-top: 20px;
    font-size: 13px;
    line-height: 22px;
    color: rgba($color: #000000, $alpha: 0.5);
  }
}
// 极速启动
.ai-preloading-icons {
  margin-top: 10.66vw;
  width: 89.33vw;
  position: relative;
  margin-left: calc(50% - 44.665vw);
}
.ai-preloading-icons__active {
  .ai-link-h,
  .ai-link-v {
    opacity: 1;
  }
}
.line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16.14%;
}
.line3 {
  margin-bottom: 0;
}
.ai-preloading-icon-container {
  position: relative;
  display: inline-block;
  width: 17.32%;
  padding-bottom: 17.32%;
  font-size: 0;
  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.ai-link-h {
  position: absolute;
  width: 6%;
  opacity: 1;
  opacity: 0;
  transition: opacity cubic-bezier(0.33, 0, 0.67, 1) 0.3s;
}
.ai-link-v {
  position: absolute;
  width: 3.33%;
  opacity: 0;
  transition: opacity cubic-bezier(0.33, 0, 0.67, 1) 0.3s;
}
.ai-link-h-1 {
  left: 47.4%;
  top: 47.36%;
}
.ai-link-h-2 {
  left: 75%;
  top: 47.36%;
}
.ai-link-v-1 {
  left: 34.47%;
  top: 23.98%;
}
.ai-link-v-2 {
  left: 89.78%;
  top: 23.98%;
}
.ai-link-v-3 {
  left: 89.78%;
  top: 63.2%;
}

.fade-in-enter-active {
  transition: opacity 0.8s ease-in !important;
}
.fade-in-enter {
  opacity: 0;
}
.fade-in-enter-to {
  opacity: 1;
}

.fade-out-leave-active {
  transition: opacity 0.8s ease-in !important;
}
.fade-out-leave-to {
  opacity: 0;
}
.fade-out-leave {
  opacity: 1;
}

.svg-black svg {
  color: #000;
}
.svg-hide svg {
  opacity: 0;
  transition: 0.2s ease;
}
</style>
